import {
  convertDateToYYYYMMFormat,
  MonthYearDatePicker,
  PageWrapper,
  STATUSPAGE,
} from '@repo/ui';
import { useFormik } from 'formik';
import { ReportsGeneralFilters } from 'presentation/app/modules/Reports/components/reports-general-filters';
import { useActivitiesQuantityPerStudent } from 'presentation/app/modules/Reports/hooks/useActivitiesQuantityPerStudent';
import {
  Button,
  Card,
  Col,
  FormGroup,
  Input,
  Label,
  Spinner,
} from 'reactstrap';

export const ActivitiesQuantityPerStudent = () => {
  // Hooks
  const {
    filters,
    loading,
    selectedSubmitBtn,
    saveFilters,
    setSelectedSubmitBtn,
    requestHandleActivitiesQuantityPerStudent,
  } = useActivitiesQuantityPerStudent();

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      entity: filters?.entity || null,
      course: filters?.course || null,
      semester: filters?.semester || null,
      unit: filters?.unit || null,
      groups: filters?.groups || [],
      period: filters?.period || convertDateToYYYYMMFormat(new Date()),
      activitiesScope: filters?.activitiesScope || 'VALIDATED_ONLY',
      model: filters?.model || 'grouped',
      showOnlyDaysWithValues: filters?.showOnlyDaysWithValues ?? false,
    },

    onSubmit: (values) => {
      const valuesToSubmit = {
        institutionHashId: values.entity?.value,
        courseHashId: values.course?.value,
        semesterHashId: values.semester?.value,
        curricularUnitHashId: values.unit?.value,
        groupHashIds: values.groups.map((group) => group.value),
        period: values.period,
        activitiesScope: values.activitiesScope,
        consolidated: values.model === 'consolidated',
        showOnlyDaysWithValues: values.showOnlyDaysWithValues,
      };

      saveFilters({ ...values });

      switch (selectedSubmitBtn) {
        case 'export-pdf':
          requestHandleActivitiesQuantityPerStudent({
            ...valuesToSubmit,
            type: 'pdf',
          });
          break;
        case 'export-excel':
          requestHandleActivitiesQuantityPerStudent({
            ...valuesToSubmit,
            type: 'excel',
          });
          break;
        default:
          break;
      }
    },
  });

  return (
    <PageWrapper title="Nº de Atividades Diárias">
      <div className="mb-4">
        <h4>Nº de Atividades Diárias</h4>
        <p className="text-muted mb-0">
          Acompanhe a quantidade de atividades realizadas diariamente por
          estudante durante o período selecionado.
        </p>
      </div>

      <Card>
        <ReportsGeneralFilters
          validation={validation}
          inputsChildren={
            <>
              <Col xl={2} className="d-flex flex-column mb-3">
                <Label>Período:</Label>
                <MonthYearDatePicker
                  validation={validation}
                  fieldName="period"
                />
              </Col>
              <Col xl={4}>
                <Label className="form-label">Validação:</Label>
                <div className="d-flex gap-4">
                  <FormGroup>
                    <Input
                      name="activitiesScope"
                      id="validated-only"
                      type="radio"
                      value="VALIDATED_ONLY"
                      checked={
                        validation.values.activitiesScope === 'VALIDATED_ONLY'
                      }
                      onChange={validation.handleChange}
                      className="form-check-input"
                      style={{ cursor: 'pointer' }}
                    />
                    <Label
                      htmlFor="validated-only"
                      className="ms-1 form-check-label"
                    >
                      Apenas validadas
                    </Label>
                  </FormGroup>
                  <FormGroup>
                    <Input
                      name="activitiesScope"
                      id="all"
                      type="radio"
                      value="ALL"
                      checked={validation.values.activitiesScope === 'ALL'}
                      onChange={validation.handleChange}
                      className="form-check-input"
                      style={{ cursor: 'pointer' }}
                    />
                    <Label htmlFor="all" className="ms-1 form-check-label">
                      Todas
                    </Label>
                  </FormGroup>
                </div>
              </Col>
             
              <Col xl={4}>
                <Label>Modelo:</Label>
                <div className="d-flex gap-4">
                  <FormGroup>
                    <Input
                      name="model"
                      id="grouped-by-group"
                      type="radio"
                      value="grouped"
                      checked={validation.values.model === 'grouped'}
                      onChange={validation.handleChange}
                      className="form-check-input"
                      style={{ cursor: 'pointer' }}
                    />
                    <Label
                      htmlFor="grouped-by-group"
                      className="ms-1 form-check-label"
                    >
                      Agrupado por grupo
                    </Label>
                  </FormGroup>
                  <FormGroup>
                    <Input
                      name="model"
                      id="consolidated"
                      type="radio"
                      value="consolidated"
                      onChange={validation.handleChange}
                      className="form-check-input"
                      style={{ cursor: 'pointer' }}
                    />
                    <Label
                      htmlFor="consolidated"
                      className="ms-1 form-check-label"
                    >
                      Consolidado
                    </Label>
                  </FormGroup>
                </div>
              </Col>
               <Col
                xl={2}
                className="d-flex flex-column justify-content-end mb-3"
              >
                <FormGroup className="form-check mb-0">
                  <Input
                    name="showOnlyDaysWithValues"
                    id="showOnlyDaysWithValues"
                    type="checkbox"
                    checked={validation.values.showOnlyDaysWithValues}
                    onChange={validation.handleChange}
                    className="form-check-input"
                    style={{ cursor: 'pointer' }}
                  />
                  <Label
                    htmlFor="showOnlyDaysWithValues"
                    className="ms-1 form-check-label"
                  >
                    Mostrar apenas dias com valores
                  </Label>
                </FormGroup>
              </Col>
            </>
          }
          buttonsChildren={
            <div className="d-flex gap-2 justify-content-end align-content-end">
              <Button
                onClick={() => {
                  setSelectedSubmitBtn('export-pdf');
                }}
                color="primary"
                type="submit"
                id="export-pdf"
                disabled={loading === STATUSPAGE.LOADING && true}
              >
                {selectedSubmitBtn === 'export-pdf' &&
                loading === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar em PDF
                    <i className="las la-file-pdf mx-2"></i>
                  </>
                )}
              </Button>
              <Button
                onClick={() => {
                  setSelectedSubmitBtn('export-excel');
                }}
                color="primary"
                type="submit"
                id={'save_button'}
                disabled={loading === STATUSPAGE.LOADING && true}
              >
                {selectedSubmitBtn === 'export-excel' &&
                loading === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Exportar para Excel
                    <i className="ms-2 ri-file-excel-2-line"></i>
                  </>
                )}
              </Button>
            </div>
          }
        />
      </Card>
    </PageWrapper>
  );
};
